import React from 'react';
import { Helmet } from 'react-helmet';
import '../styles/Styles.css';

const Privacy = () => {
  return (
    <div className="agreement-container">
      <Helmet>
        <title>Политика конфиденциальности - ReserveCar</title>
        <meta name="description" content="Политика конфиденциальности." />
      </Helmet>

      <div className="agreement-card">
        <h1 className="agreement-title">Политика конфиденциальности</h1>

        <div className="agreement-content">
          <h2>1. Общие положения</h2>
          <p>
            Настоящая политика обработки персональных данных составлена в
            соответствии с требованиями Федерального закона от 27.07.2006. №
            152-ФЗ «О персональных данных» (далее — Закон о персональных данных) и
            определяет порядок обработки персональных данных и меры по обеспечению
            безопасности персональных данных, предпринимаемые ИП Михайлов (далее —
            Оператор).
          </p>
          <p>
            1.1. Оператор ставит своей важнейшей целью и условием осуществления своей
            деятельности соблюдение прав и свобод человека и гражданина при обработке
            его персональных данных, в том числе защиты прав на неприкосновенность
            частной жизни, личную и семейную тайну.
          </p>
          <p>
            1.2. Настоящая политика Оператора в отношении обработки персональных данных
            (далее — Политика) применяется ко всей информации, которую Оператор может
            получить о посетителях веб-сайта https://reservecar.u.
          </p>

          <h2>2. Основные понятия, используемые в Политике</h2>
          <ul>
            <li>
              <strong>Автоматизированная обработка персональных данных</strong> — обработка
              персональных данных с помощью средств вычислительной техники.
            </li>
            <li>
              <strong>Блокирование персональных данных</strong> — временное прекращение
              обработки персональных данных (за исключением случаев, если обработка
              необходима для уточнения персональных данных).
            </li>
            <li>
              <strong>Веб-сайт</strong> — совокупность графических и информационных
              материалов, а также программ для ЭВМ и баз данных, обеспечивающих их
              доступность в сети интернет по сетевому адресу https://reservecar.u.
            </li>
            <li>
              <strong>Информационная система персональных данных</strong> — совокупность
              содержащихся в базах данных персональных данных и обеспечивающих их
              обработку информационных технологий и технических средств.
            </li>
            <li>
              <strong>Обезличивание персональных данных</strong> — действия, в результате
              которых невозможно определить без использования дополнительной информации
              принадлежность персональных данных конкретному Пользователю или иному
              субъекту персональных данных.
            </li>
            <li>
              <strong>Обработка персональных данных</strong> — любое действие (операция) или
              совокупность действий (операций), совершаемых с использованием средств
              автоматизации или без использования таких средств с персональными данными,
              включая сбор, запись, систематизацию, накопление, хранение, уточнение
              (обновление, изменение), извлечение, использование, передачу
              (распространение, предоставление, доступ), обезличивание, блокирование,
              удаление, уничтожение персональных данных.
            </li>
            <li>
              <strong>Оператор</strong> — государственный орган, муниципальный орган,
              юридическое или физическое лицо, самостоятельно или совместно с другими
              лицами организующие и/или осуществляющие обработку персональных данных, а
              также определяющие цели обработки персональных данных, состав персональных
              данных, подлежащих обработке, действия (операции), совершаемые с персональными
              данными.
            </li>
            <li>
              <strong>Персональные данные</strong> — любая информация, относящаяся прямо или
              косвенно к определенному или определяемому Пользователю веб-сайта
              https://reservecar.u.
            </li>
            <li>
              <strong>Пользователь</strong> — любой посетитель веб-сайта https://reservecar.u.
            </li>
          </ul>

          <h2>3. Основные права и обязанности Оператора</h2>
          <h3>3.1. Оператор имеет право:</h3>
          <ul>
            <li>Получать от субъекта персональных данных достоверные информацию и/или документы, содержащие персональные данные.</li>
            <li>Продолжать обработку персональных данных без согласия субъекта, если имеются законные основания.</li>
            <li>Самостоятельно определять состав и перечень мер для обеспечения выполнения обязанностей.</li>
          </ul>

          <h3>3.2. Оператор обязан:</h3>
          <ul>
            <li>Предоставлять субъекту персональных данных информацию, касающуюся обработки его персональных данных.</li>
            <li>Организовывать обработку персональных данных в соответствии с законодательством РФ.</li>
            <li>Сообщать в уполномоченный орган по защите прав субъектов персональных данных по запросу необходимую информацию.</li>
          </ul>

          <h2>4. Основные права и обязанности субъектов персональных данных</h2>
          <h3>4.1. Субъекты персональных данных имеют право:</h3>
          <ul>
            <li>Получать информацию о обработке своих персональных данных, за исключением случаев, предусмотренных федеральными законами.</li>
            <li>Требовать от оператора уточнения, блокирования или уничтожения неполных или устаревших данных.</li>
            <li>Отозвать согласие на обработку персональных данных.</li>
          </ul>

          <h3>4.2. Субъекты персональных данных обязаны:</h3>
          <ul>
            <li>Предоставлять Оператору достоверные данные о себе.</li>
            <li>Сообщать Оператору об уточнении своих персональных данных.</li>
          </ul>

          <h2>5. Принципы обработки персональных данных</h2>
          <ul>
            <li>Обработка персональных данных осуществляется на законной и справедливой основе.</li>
            <li>Обработка ограничивается достижением конкретных, заранее определенных целей.</li>
            <li>Не допускается объединение баз данных с несовместимыми целями обработки.</li>
          </ul>

          <h2>6. Цели обработки персональных данных</h2>
          <p>Цели обработки: предоставление доступа Пользователю к сервисам и информации на веб-сайте.</p>
          <p>Персональные данные: электронный адрес, номера телефонов, имя.</p>

          <h2>7. Условия обработки персональных данных</h2>
          <p>
            Обработка персональных данных осуществляется с согласия субъекта персональных
            данных или в иных случаях, предусмотренных законодательством Российской
            Федерации.
          </p>

          <h2>8. Порядок сбора, хранения, передачи и других видов обработки персональных данных</h2>
          <p>
            Оператор обеспечивает сохранность персональных данных и принимает все необходимые
            меры для их защиты в соответствии с законодательством.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;

